import { Link } from "react-router-dom";
import { InstagramLogo, FacebookLogo, WhatsappLogo, EnvelopeSimple, Phone, MapPin } from "@phosphor-icons/react";
import Logo from "@/components/Logo";
import { SITE } from "@/lib/site";

export default function Footer() {
    return (
        <footer className="relative bg-[#080E20] text-white overflow-hidden" data-testid="site-footer">
            <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24 pt-24 pb-12">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-16 border-b border-white/10">
                    <div className="lg:col-span-5">
                        <Logo className="mb-6" />
                        <h3 className="font-serif text-3xl sm:text-4xl mt-4 max-w-md leading-tight">
                            Crafted journeys for travelers who expect more than a booking.
                        </h3>
                    </div>

                    <div className="lg:col-span-3">
                        <p className="overline mb-5">Explore</p>
                        <ul className="space-y-3 font-sans text-white/70 text-sm">
                            <li><Link to="/destinations" className="hover:text-gold transition-colors">Destinations</Link></li>
                            <li><Link to="/packages" className="hover:text-gold transition-colors">Tour Packages</Link></li>
                            <li><Link to="/services" className="hover:text-gold transition-colors">Services</Link></li>
                            <li><Link to="/testimonials" className="hover:text-gold transition-colors">Traveler Stories</Link></li>
                            <li><Link to="/about" className="hover:text-gold transition-colors">About Us</Link></li>
                        </ul>
                    </div>

                    <div className="lg:col-span-4">
                        <p className="overline mb-5">Reach us</p>
                        <ul className="space-y-4 font-sans text-white/70 text-sm">
                            <li className="flex gap-3"><MapPin size={18} weight="light" className="text-gold shrink-0 mt-0.5" /> <span>{SITE.address}</span></li>
                            <li className="flex gap-3"><Phone size={18} weight="light" className="text-gold shrink-0 mt-0.5" /> <a href={`tel:+${SITE.whatsappRaw}`} className="hover:text-gold">{SITE.whatsappDisplay}</a></li>
                            <li className="flex gap-3"><EnvelopeSimple size={18} weight="light" className="text-gold shrink-0 mt-0.5" /> <a href={`mailto:${SITE.email}`} className="hover:text-gold">{SITE.email}</a></li>
                        </ul>
                        <div className="flex items-center gap-4 mt-8">
                            <a data-testid="social-instagram" aria-label="Instagram" href={SITE.social.instagram} target="_blank" rel="noreferrer" className="w-11 h-11 border border-white/15 grid place-items-center hover:border-gold hover:text-gold transition-colors"><InstagramLogo size={18} weight="light" /></a>
                            <a data-testid="social-facebook" aria-label="Facebook" href={SITE.social.facebook} target="_blank" rel="noreferrer" className="w-11 h-11 border border-white/15 grid place-items-center hover:border-gold hover:text-gold transition-colors"><FacebookLogo size={18} weight="light" /></a>
                            <a data-testid="social-whatsapp" aria-label="WhatsApp" href={SITE.social.whatsapp} target="_blank" rel="noreferrer" className="w-11 h-11 border border-white/15 grid place-items-center hover:border-gold hover:text-gold transition-colors"><WhatsappLogo size={18} weight="light" /></a>
                        </div>
                    </div>
                </div>

                <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-6 border-t border-white/10">
                    <p className="font-sans text-xs text-white/40 tracking-wide">© {new Date().getFullYear()} Midasis Flyaway. All journeys reserved.</p>
                    <p className="font-sans text-xs text-white/40 tracking-wide">Crafted in Hyderabad · Trusted worldwide</p>
                </div>
            </div>
        </footer>
    );
}
